module.exports = __webpack_public_path__ + "static/media/twitter.c6c96c60.svg";